import { render, staticRenderFns } from "./buyRecord.vue?vue&type=template&id=aa4d7580&scoped=true"
import script from "./buyRecord.vue?vue&type=script&lang=js"
export * from "./buyRecord.vue?vue&type=script&lang=js"
import style0 from "./buyRecord.vue?vue&type=style&index=0&id=aa4d7580&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4d7580",
  null
  
)

export default component.exports